<p-checkbox
    [binary]="true"
    [inputId]="inputId()"
    [invalid]="showInvalid()"
    [disabled]="disabled()"
    [ngModel]="checked()"
    (ngModelChange)="handleChange($event)"
    (onBlur)="markTouched()"
    [ngModelOptions]="standaloneNgModel" />
@if (label()) {
    <label
        [for]="inputId()"
        class="ml-2 mb-0">
        {{ label() }}
    </label>
}
